import api from '../api';

export const login = async body => {
	const url = '/auth/login';
	const response = await api.post(url, body);
	return response.data;
};

export const getPermissions = async refreshToken => {
	const url = `/auth/permissoes`;
	const query = refreshToken ? `?refreshToken=${refreshToken}` : '';
	const response = await api.get(url + query);
	return response.data;
};

export const getUsersGroup = async () => {
	const url = `/perfil/gruposUsuarios`;
	const response = await api.get(url);
	return response.data;
};

interface IBodyDeleteUser {
	email: 'string';
	deleteDb: boolean;
}

export const deleteUser = async (body: IBodyDeleteUser) => {
	const url = `/auth/deleteUser`;
	const response = await api.post(url, body);
	return response.data;
};

export const logout = async () => {
	const url = '/auth/logout';
	const response = await api.get(url);
	return response.data;
};
